module.exports = __webpack_public_path__ + "img/step6-02.fe15a06f.jpg";